import { QUES_COMPONENT_TYPES } from '../componentTypes';

export default [
  {
    sequenceNumber: 21,
    content:
      "How similar are the Buyer's and Target's cultures?  Consider: Leadership and Management Style, Collaboration and Teamwork, Autonomy and Involvement, Adaptability -- Speed, Innovation, and Risk, and Work Environment and Employee Experience",
    subSection: 'Culture',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 5,
      extremeTexts: [
        'Very Similar',
        'Similar',
        'Somewhat Similar',
        'Dissimilar',
        'Very Dissimilar',
      ],
    },
  },
  {
    sequenceNumber: 22,
    content:
      'What is the scale of change expected as a result of the integration across the following levers? ',
    subSection: 'Change Management',
    type: QUES_COMPONENT_TYPES.MULTIRADIO,
    options: [
      {
        section: 'People (Internal)',
        options: [{ text: 'Minimal' }, { text: 'Significant' }],
      },
      {
        section: 'Process (Internal)',
        options: [{ text: 'Minimal' }, { text: 'Significant' }],
      },
      {
        section: 'Technology (Internal)',
        options: [{ text: 'Minimal' }, { text: 'Significant' }],
      },
      {
        section: 'Go-to-Market (External)',
        options: [{ text: 'Minimal' }, { text: 'Significant' }],
      },
    ],
  },
  {
    sequenceNumber: 23,
    subTitle: "Target's Employee Base Footprint",
    content: "What is the geographic footprint of the Target's employee base?",
    subSection: 'Geography',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: [
        'Highly Concentrated',
        'Intermediate',
        'Largely Dispersed',
      ],
    },
  },
  {
    sequenceNumber: 24,
    content:
      'How challenging is benefits harmonization (including pensions) expected to be?',
    subSection: 'Talent',
    subTitle: 'Benefits Harmonization',
    type: QUES_COMPONENT_TYPES.SCALE,
    // cols: 3,
    options: {
      count: 3,
      extremeTexts: [
        'Not Challenging',
        'Somewhat Challenging',
        'Very Challenging',
      ],
    },
  },
  {
    sequenceNumber: 25,
    subTitle: 'Communications Team in Place',
    content:
      'Is a dedicated Communications team in place that will lead the development of the full transaction Communications plan (pre-Close, Day 1 and post-Close) considering the desired experience for all stakeholders?',
    subSection: 'Communications',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: 'Yes' }, { text: 'No' }],
  },
  {
    sequenceNumber: 26,
    subTitle: 'Leadership Roles',
    needOptionTextChildren: true,
    content:
      'Are significant changes to leadership roles (e.g., L1 and L2 roles) expected?',
    subSection: 'Change Management',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['Minimal Change', 'Moderate Change', 'Significant Change'],
    },
  },
  {
    sequenceNumber: 27,
    subTitle: 'Talent Retention',
    content:
      'To what extent are you concerned about retaining key talent / to what extent is retaining key talent critical to the success of the transaction? ',
    subSection: 'Talent',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: [
        'Little to No Concern',
        'Some Concern',
        'Highly Concerned',
      ],
    },
  },
];
